<template>
  <div class="minapplets">
    <div class="outmain ba_f formwidth">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="$t('plugin.miniappSet.tabBasic')" name="1">
          <el-form ref="form" :model="form" :rules="rules" label-width="180px" class="mar_t20">
            <el-form-item :label="$t('plugin.miniappSet.miniName')" prop="miniName" :required="true">
              <el-input v-model="form.miniName" :placeholder="$t('plugin.miniappSet.miniNamePh')" />
            </el-form-item>
            <el-form-item :label="$t('plugin.miniappSet.miniAppId')" prop="miniAppId" :required="true">
              <el-input v-model="form.miniAppId" :placeholder="$t('plugin.miniappSet.miniAppIdPh')" />
              <div class="yb_margin lh16">{{ $t('plugin.miniappSet.appIdHint') }}</div>
            </el-form-item>
            <el-form-item :label="$t('plugin.miniappSet.miniSecret')" prop="miniSecret" :required="true">
              <el-input v-model="form.miniSecret" :placeholder="$t('plugin.miniappSet.miniSecretPh')" :type="passw">
                <i slot="suffix" :class="icon" @click="showPass" />
              </el-input>
              <div class="yb_margin lh16">{{ $t('plugin.miniappSet.appSecretHint') }}</div>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane :label="$t('plugin.miniappSet.tabUserList')" name="2">
          <div class="ba_f">
            <div class="pad_20">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                class="tablecenter"
              >
                <el-table-column label="ID" prop="memberId" width="80" />
                <el-table-column prop="userName" :label="$t('plugin.miniappSet.userInfo')">
                  <template slot-scope="scope">
                    <div class="flex pad_tb_10 flex-center">
                      <div class=""><img class="namelogo" :src="scope.row.portrait">
                      </div>
                      <div class="flex-col mar_l20 t_l">
                        <div class="overflowlnr">{{ scope.row.memberName }}</div>
                        <div class="fon_12 color_9">{{ $t('plugin.miniappSet.regTime') }}{{ scope.row.createdAt }}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('plugin.miniappSet.linkedRider')" prop="storeName" align="left">
                  <template slot-scope="scope">
                    <div class="flex pad_tb_10 flex-center">
                      <div class="flex-col mar_l20 t_l">
                        <div class="overflowlnr">{{ scope.row.storeName }}</div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="t_l pad_20">
              <el-pagination
                background
                layout="prev, pager, next"
                :total="page.total"
                :page-size="page.pagesize"
                :current-page.sync="page.currentPage"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('plugin.miniappSet.tabDownload')" name="3">
          <div class="ba_f">
            <div class="pad_20">
              <el-form ref="form2" :model="form2" label-width="180px" class="">
                <div class="stepsLeft mar_t20">
                  <el-steps direction="vertical" :active="3">
                    <el-step :title="$t('plugin.miniappSet.step1Title')">
                      <template slot="description">
                        <div class="xiazai">
                          <a href="https://developers.weixin.qq.com/miniprogram/dev/devtools/download.html" target="_blank">
                            <el-button type="primary" class>{{ $t('plugin.miniappSet.downloadDevTool') }}</el-button>
                          </a>
                        </div>
                      </template>
                    </el-step>
                    <el-step :title="$t('plugin.miniappSet.step2Title')">
                      <template slot="description">
                        <div class="xiazai">
                          <a :href="backendPath" download="下载小程序代码包">
                            <el-button type="primary">{{ $t('plugin.miniappSet.downloadCodePack') }}</el-button>
                          </a>
                        </div>
                      </template>
                    </el-step>
                    <el-step :title="$t('plugin.miniappSet.step3Title')" />
                  </el-steps>
                </div>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-show="activeName!='2' && activeName!='3'" class="mar_t20 ba_f pad_20 t_c">
      <el-button type="primary" @click="onSubmit">{{ $t('common.save') }}</el-button>
    </div>
  </div>
</template>
<script>
import { getMerchantConfig, postMerchantConfig } from '@/api/set'
import { getUser } from '@/api/plugins'
import index from '../../api'

export default {
  computed: {
    rules() {
      return {
        miniName: [{ required: true, message: this.$t('plugin.miniappSet.validateMiniName'), trigger: 'blur' }],
        miniAppId: [{ required: true, message: this.$t('plugin.miniappSet.validateAppId'), trigger: 'blur' }],
        miniSecret: [{ required: true, message: this.$t('plugin.miniappSet.validateSecret'), trigger: 'blur' }]
      }
    }
  },
  data() {
    return {
      backendPath: '',
      activeName: '1',
      form: {
        miniName: '',
        miniAppId: '',
        miniSecret: '',
      },
      passw: 'password',
      icon: 'iconfont iconyanjing',
      tableData: [],
      form2: {},
      page: {
        total: 0,
        size: 10,
        currentPage: 1
      }
    }
  },
  created() {
    this.backendPath = index.backendPath + 'delivery/cloud/mini-down'
    this.init()
  },
  methods: {
    async init() {
      if (this.activeName === '1') {
        this.bus.$emit('loading', true)
        this.formData()
      } else if (this.activeName === '2') {
        this.fetchData()
      } else if (this.activeName === '3') {
        this.bus.$emit('loading', false)
      }
    },
    async handleClick() {
      this.bus.$emit('loading', true)
      if (this.activeName === '1') {
        this.formData()
      } else if (this.activeName === '2') {
        this.fetchData()
      } else if (this.activeName === '3') {
        this.bus.$emit('loading', false)
      }
      this.code = 1
    },
    async formData() {
      const { data } = await getMerchantConfig({ ident: 'merchantConfig' })
      this.form2 = this.form
      this.form = Object.assign(this.form2, data)
      this.bus.$emit('loading', false)
    },
    async fetchData() {
      this.listLoading = true
      const { data, count } = await getUser({ page: this.page.currentPage })
      this.page.total = count
      this.tableData = data
      this.bus.$emit('loading', false)
      setTimeout(() => {
        this.listLoading = false
      }, 100)
    },
    handleCurrentChange(val) {
      this.page.currentPage = val
      this.fetchData()
    },
    async onSubmit() {
      this.$refs['form'].validate(async(valid) => {
        if (valid) {
          this.form.ident = 'merchantConfig'
          const { msg } = await postMerchantConfig(this.form)
          this.$baseMessage(msg, 'success')
          this.init()
        } else {
          return false
        }
      })
    },
    showPass() {
      if (this.passw == 'text') {
        this.passw = 'password'
        this.icon = 'iconfont iconyanjing'
      } else {
        this.passw = 'text'
        this.icon = 'iconfont iconyanjing1'
      }
    }
  }
}
</script>
<style  lang="scss" scoped>
.orderpop p {
  line-height: 24px;
}

.msgtext {
  text-indent: -60px;
  padding-left: 70px;
}
.imgCode {
  width: 200px;
  height: 200px;
}
.waitTime {
  font-size: 26px;
  margin-top: 10px;
  color: #1d42ab;
}
.loadWait {
  width: 32px;
  height: 32px;
}
.el-button.is-plain:focus,
.el-button.is-plain:hover {
  border-color: #155bd4;
  color: #fff;
}

.stepsLeft {
  height: 330px;
  padding-left: 30px;
  padding-top: 10px;
  padding-bottom: 20px;

 ::v-deep .el-step.is-vertical .el-step__line {
  left: 12px;
  width: 1px;
}
::v-deep .el-step__icon {
  width: 25px;
  height: 25px;
}
::v-deep .el-step__title.is-finish,
::v-deep .el-step__description.is-finish {
  color: #333;
}
::v-deep .el-step__line-inner {
  border: none;
  border-left: 1px solid #2A75ED;
}
::v-deep .el-step__icon.is-text {
  border: 1px solid;
}
}
.tablecenter th,
.tablecenter td {
  text-align: center !important;
}
</style>
